// @see https://stackoverflow.com/a/7616484
const hash = (str) => {
    let hashed = 0, i, chr;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hashed = ((hashed << 5) - hashed) + chr;
        hashed |= 0;
    }
    return hashed;
};

export default hash;
